import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { DataTablesModule } from 'angular-datatables';
import {
  DevExtremeModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTemplateModule
} from 'devextreme-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { ChartsModule } from 'ng2-charts';
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { TourMatMenuModule } from 'ngx-tour-md-menu';
import { AppRoutingModule } from '../app.routing';
import { SharedModule } from '../shared';
import { CanDeactivateGuard } from '../shared/can-deactivate/can-deactivate.guard';
import { CanSessionDeactivateGuard } from '../shared/can-deactivate/can-sessiondeactive.guard';
import { DateFormatPipe, DateTimeFormatPipe } from './DateFormat.Pipe';
import { DateMon } from './Datemon';
import { DateShort } from './Dateshort';
import { AddgiverComponent } from './addgiver/addgiver.component';
import { AddnewpatientComponent } from './addnewpatient/addnewpatient.component';
import { AddpartnerComponent } from './addpartner/addpartner.component';
import { AddpatientComponent } from './addpatient/addpatient.component';
import { AnybodypartComponent } from './anybodypart/anybodypart.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { AssementComponent } from './assement/assement.component';
import { ConfirmtempComponent } from './confirmtemp/confirmtemp.component';
import { CustomMaxDirective } from './custom-max-validator.directive';
import { CustomMinDirective } from './custom-min-validator.directive';
import { DashComponent } from './dash/dash.component';
import { DischargetypePipe } from './dischargetype.pipe';
import { Documentpage1Component } from './documentpage1/documentpage1.component';
import { EditsymptomComponent } from './editsymptom/editsymptom.component';
import { HospitalComponent } from './hospital.component';
import { HospitalmetricsComponent } from './hospitalmetrics/hospitalmetrics.component';
import { KeysPipePipe } from './keys-pipe.pipe';
import { LoginfromonboardComponent } from './loginfromonboard/loginfromonboard.component';
import { MessagehospComponent } from './messagehosp/messagehosp.component';
import { SinglelistComponent } from './messagehosp/singlelist/singlelist.component';
import { ThreadlistComponent } from './messagehosp/threadlist/threadlist.component';
import { MessagesComponent } from './messages/messages.component';
import { MytodoComponent } from './mytodo/mytodo.component';
import { NewsymptomComponent } from './newsymptom/newsymptom.component';
import { OnlyAlphanumericDirective } from './only-alphanumeric.directive';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlycharactersDirective } from './onlycharacters.directive';
import { PSAssementComponent } from './passement/passement.component';
import { PatdashComponent } from './patdash/patdash.component';
import { PatientdetailsComponent } from './patientdetails/patientdetails.component';
import { PatqualifiComponent } from './patqualifi/patqualifi.component';
import { PatsummaryComponent } from './patsummary/patsummary.component';
import { PdfpageComponent } from './pdfpage/pdfpage.component';
import { PostoppComponent } from './postopp/postopp.component';
import { ProfileComponent } from './profile/profile.component';
import { ProfilesecurityquestionComponent } from './profilesecurityquestion/profilesecurityquestion.component';
import { QuestionComponent } from './questions/questions.component';
import { Restpass1Component } from './restpass/restpass.component';
import { SnfpatientComponent } from './snfpatient/snfpatient.component';
import { StringFormatPipePipe } from './string-format-pipe.pipe';
import { SafeHtmlPipe } from './string-html.pipe';
import { SurveymetricsComponent } from './surveymetrics/surveymetrics.component';
import { ToolkittComponent } from './toolkit/toolkit.component';
import { DischargeHospitalPipe } from './viewsummary/discharge-hospital.pipe';
import { DischargeTypePipe } from './viewsummary/discharge-type.pipe';
import { DischargedateFormatPipe } from './viewsummary/dischargedate-format.pipe';
import { DischargestatusPipe } from './viewsummary/dischargestatus.pipe';
import { ExportSurveyComponent } from './viewsummary/export-survey/export-survey.component';
import { DropzoneDirective } from './viewsummary/patient-documents/dropzone.directive';
import { PatientDocumentsComponent } from './viewsummary/patient-documents/patient-documents.component';
import { ViewsummaryComponent } from './viewsummary/viewsummary.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    MatCardModule,
    TourMatMenuModule.forRoot(),
    MatIconModule,
    // DataTablesModule,
    BsDropdownModule.forRoot(),
    PdfViewerModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TimepickerModule.forRoot(),
    PaginationModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    MatDialogModule,
    AppRoutingModule,
    DevExtremeModule,
    // ChartsModule,
    Ng2SearchPipeModule,
    NgxSliderModule,
    ImageCropperModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxTemplateModule,
    DxButtonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    AddpartnerComponent,
    AddgiverComponent,
    AddpartnerComponent,
    AddpatientComponent,
    AnybodypartComponent,
    HospitalComponent,
    AppointmentsComponent,
    AssementComponent,
    PSAssementComponent,
    DashComponent,
    Documentpage1Component,
    HospitalmetricsComponent,
    MessagesComponent,
    MytodoComponent,
    NewsymptomComponent,
    EditsymptomComponent,
    PdfpageComponent,
    AddpartnerComponent,
    PostoppComponent,
    ProfileComponent,
    SnfpatientComponent,
    SurveymetricsComponent,
    ViewsummaryComponent,
    PatsummaryComponent,
    PatdashComponent,
    PatqualifiComponent,
    PatientdetailsComponent,
    OnlyNumberDirective,
    KeysPipePipe,
    OnlycharactersDirective,
    OnlyAlphanumericDirective,
    ToolkittComponent,
    AddnewpatientComponent,
    StringFormatPipePipe,
    MessagehospComponent,
    QuestionComponent,
    DateFormatPipe,
    DateTimeFormatPipe,
    SafeHtmlPipe,
    DateShort,
    DateMon,
    CustomMinDirective,
    CustomMaxDirective,
    ConfirmtempComponent,
    DischargeHospitalPipe,
    DischargeTypePipe,
    DischargestatusPipe,
    DischargedateFormatPipe,
    LoginfromonboardComponent,
    DischargetypePipe,
    ProfilesecurityquestionComponent,
    SinglelistComponent,
    ThreadlistComponent,
    Restpass1Component,
    ExportSurveyComponent,
    PatientDocumentsComponent,
    DropzoneDirective
  ],
  entryComponents: [
    ConfirmtempComponent
  ],
  providers: [CanDeactivateGuard, CanSessionDeactivateGuard]
})
export class HospitalModule { }
